import { NewsModel } from '../../../types/news/newsModel'
import { NewsType } from './types'
import { SAVE_NEWS, SET_LOADING_NEWS } from './actionTypes'

const initialState: NewsModel = {
	actualite_exploitation: [],
	actualite_marketing: [],
	loading: true,
	locale: undefined
}

const news = (
	state: NewsModel = initialState,
	action: NewsType
): NewsModel => {
	switch (action.type) {
		case SAVE_NEWS: {
			const payload: NewsModel = action.payload as NewsModel

			return {
				...state,
				...payload
			} || initialState
		}
		case SET_LOADING_NEWS: {
			const payload: boolean = action.payload as boolean

			return {
				...state,
				loading: payload
			}
		}
		default:
			return state
	}
}

export default news
